export const iconFontAwesomeArrowsSquareCaretLeft = (
	<i className="fa-solid fa-square-caret-left"></i>
);
